import getOrg from './org.vue';
import getRecent from './recent.vue';
import getGroup from './group.vue';
import getStar from './group-star.vue';
import getFriend from './group-friend.vue';

export default {
    getOrg,
    getRecent,
    getGroup,
    getStar,
    getFriend,
};
